import { Grid } from '@mui/material'
import { Box } from '@mui/system'
import React, { useContext } from 'react'

import SimpleContainer from '../../../base/components/Container/SimpleContainer'
import Breadcrumb from '../../../base/components/Template/Breadcrumb/Breadcrumb'
import AuthContext from '../../../base/contexts/JWTAuthContext'
import UnidadMedidaListado from '../../unidadMedida/view/listado/UnidadMedidaListado'
import { grupoUnidadMedidaRouteMap } from '../grupoUnidadMedidaRoutes'
import GrupoUnidadMedidaListado from './listado/GrUniMedListado'

//import { productosRouteMap } from '../../productos/ProductosRoutesMap'
//import UnidadMedidaListado from '../components/UnidadMedidaListado'

const GrupoUnidadMedidaGestion = () => {
  const { user } = useContext(AuthContext)
  // in this case *props are stored in the state of parent component

  return (
    <>
      <SimpleContainer>
        <div className="breadcrumb">
          <Breadcrumb routeSegments={[grupoUnidadMedidaRouteMap.gestion]} />
        </div>
        <Grid container spacing={2}>
          <Grid
            size={{
              lg: 12,
              md: 12,
              xs: 12,
            }}
          >
            <GrupoUnidadMedidaListado />
          </Grid>
        </Grid>
        <Box py="12px" />
      </SimpleContainer>
    </>
  )
}

export default GrupoUnidadMedidaGestion
